import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  min-height: 0;
  position: relative;

  .analysis-header {
    border-bottom: 1px solid ${(props) => props.theme.$gray300};
  }

  .analysis-header-actions {
    gap: 12px;
  }

  .generate-bidder-file-button {
    background: ${(props) => props.theme.$primary};
    border: 1px solid ${(props) => props.theme.$primary};
    border-radius: 6px;
    color: ${(props) => props.theme.$white};
    font-size: 14px;
    font-weight: 500;
    padding: 6px 16px;
    white-space: nowrap;

    &:hover:not(:disabled) {
      color: ${(props) => props.theme.$white};
      filter: brightness(0.94);
    }

    .material-icons {
      font-size: 18px;
      margin-right: 8px;
    }
  }

  .analysis-columns {
    min-height: 0;
    padding-bottom: 46px;
  }

  .analysis-main {
    min-width: 0;
  }

  .analysis-body {
    min-height: 0;
  }

  .analysis-preview {
    width: 45%;
    min-width: 320px;
    max-width: 960px;
    background: ${(props) => props.theme.$gray100};
  }

  .analysis-preview-body {
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
`;
